// Inputs que não recebem texto: com foco neles (ex.: depois de marcar um checkbox), os atalhos
// de letra continuam valendo.
const NON_TEXT_INPUT_TYPES = new Set([
  'button',
  'checkbox',
  'color',
  'file',
  'hidden',
  'image',
  'radio',
  'range',
  'reset',
  'submit'
])

/** Se o evento de teclado veio de um campo onde o usuário digita; atalhos globais devem ignorá-lo. */
const isEditableTarget = (target: EventTarget | null) => {
  if (target instanceof HTMLInputElement) {
    return !NON_TEXT_INPUT_TYPES.has(target.type)
  }
  return (
    target instanceof HTMLTextAreaElement ||
    target instanceof HTMLSelectElement ||
    (target instanceof HTMLElement && target.isContentEditable === true)
  )
}

export default isEditableTarget
